export enum MessageSource {
	NEW = 'NEW',
	FORWARD = 'FORWARD',
	GROUP = 'GROUP',
}
